import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AccountVerify() {
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    const token = new URLSearchParams(window.location.search).get("token") || "";
    window.history.replaceState(null, "", "/account/verify");
    api.post("/auth/verify", { token }, { withCredentials: true })
      .then(() => nav("/account", { replace: true }))
      .catch(() => setErr("This sign-in link is invalid, expired, or already used."));
  }, [nav]);
  return (
    <main className="max-w-xl mx-auto px-5 py-20" data-testid="account-verify-page">
      {err ? (
        <div data-testid="account-verify-error">
          <p className="text-[#B3261E]">{err}</p>
          <a href="/account" className="underline text-sm mt-3 inline-block">Request a new link</a>
        </div>
      ) : <p className="flex items-center gap-2"><Loader2 className="animate-spin" size={16} /> Signing you in…</p>}
    </main>
  );
}
